import { API_BASE_URL } from "../config/api";
import { fetchWithActor } from "../api/actor";

// Fill the RFQ's stored Excel files with the validated prices
// (POST /excel/automation/process/:rfqId) on Render's backend: the automation
// outlasts Vercel's 10 s limit. Resolves to the raw Response; the caller reads
// its status and body.

export interface ExcelPriceLine {
  identifier: string;
  lineNumber: string;
  /** Maps to the item's original row in the customer's workbook. */
  orderIndex: number | null | undefined;
  itemNumber: string | null | undefined;
  productName: string;
  price: number | null | undefined;
  supplierRemark: string | null;
}

export const runExcelAutomationRequest = (rfqId: number, priceData: ExcelPriceLine[]) =>
  fetchWithActor(`${API_BASE_URL}/excel/automation/process/${rfqId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include", // Use session-based auth like other API calls
    body: JSON.stringify({ priceData }),
  });
